import {ModuleIdentifier} from "@repo/services";

/**
 * The maximum priority value string ('high') used as the upper bound in priority-level checks.
 */
export const maxPriority = 'high';
/**
 * The minimum priority value string ('low') used as the lower bound in priority-level checks.
 */
export const minPriority = 'low';

/**
 * Determines whether the "raise priority" action should be disabled because the priority is already at its maximum.
 *
 * @param priority - Current priority value to check.
 * @returns True if the priority is already at the maximum ('high') and raising it further should be disabled.
 */
export const shouldDisableRaisePriority = (priority: string | undefined) => {
    return priority?.toLowerCase() === maxPriority;
};

/**
 * Determines whether the "lower priority" action should be disabled because the priority is already at its minimum.
 *
 * @param priority - Current priority value to check.
 * @returns True if the priority is already at the minimum ('low') and lowering it further should be disabled.
 */
export const shouldDisableLowerPriority = (priority: string | undefined) => {
    return priority?.toLowerCase() === minPriority;
};

/**
 * Determines whether priority increment/decrement controls should be disabled, based on module type and status. For aimOpportunity records, priority can only be changed while status is Draft, Mapping, or Pending.
 *
 * @param module - The module the priority incrementer is being shown for.
 * @param status - The current status of the record.
 * @returns True if the priority incrementer should be disabled for this module/status combination.
 */
export const shouldDisableIncrementer = (module: ModuleIdentifier, status: string) => {
    let shouldDisable = false;
    if (module === ModuleIdentifier.aimOpportunity && status !== 'Draft' && status !== 'Mapping' && status !== 'Pending') {
        shouldDisable = true;
    }
    return shouldDisable;
}
